export const OBJECT_INTERPOLATE_STRING = "\\$<< ([\\w\\d[\\].]+) >>";
